import { Routes } from '@angular/router'

import { NOT_FOUND_PATH } from '~const/index'

import { AnalystCoverageTabComponent } from './tabs/analyst-coverage-tab/analyst-coverage-tab.component'
import { MarketCupTabComponent } from './tabs/market-cup-tab/market-cup-tab.component'
import { SectorTabComponent } from './tabs/sector-tab/sector-tab.component'
import { ANALYST_COVERAGE_PATH, MARKET_CAP_PATH, SECTOR_PATH } from './constants'
import { PerformanceComponent } from './performance.component'

export const PERFORMANCE_ROUTES: Routes = [
  {
    path: '',
    component: PerformanceComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: MARKET_CAP_PATH,
      },
      {
        path: ANALYST_COVERAGE_PATH,
        component: AnalystCoverageTabComponent,
      },
      {
        path: MARKET_CAP_PATH,
        component: MarketCupTabComponent,
      },
      {
        path: SECTOR_PATH,
        component: SectorTabComponent,
      },
    ],
  },
  { path: '**', redirectTo: `/${NOT_FOUND_PATH}` },
]
